"use strict";

export const serializeVuetifyLocale = (locale) => {
  if (locale === "zh") return "zhHant";
  return locale;
};

export async function loadLocale(component, locale) {
  return await import(`/src/lang/${locale}`).then((messages) => {
    component.$i18n.setLocaleMessage(locale, messages.default);
    component.loadedLanguages.push(locale);
    component.$i18n.locale = locale;
    component.$vuetify.lang.current = serializeVuetifyLocale(locale);
  });
}
